import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable, switchMap } from 'rxjs';
import { MsalService } from '@azure/msal-angular';
import { SessionStorageService } from '../services/session-storage/session-storage.service';
import { environment } from 'src/environments/environment';
import { MsalAccountService } from '../services/msal-account/msal-account.service';

@Injectable()
export class MsalAuthInterceptor implements HttpInterceptor {
  finalRequest: HttpRequest<any>;
  headers: {};

  constructor(
    private authService: MsalService,
    private sessionStorageService: SessionStorageService,
    private msalAccountService: MsalAccountService
  ) { }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    if (request.url.includes(environment.proxy.login)) {
      this.finalRequest = request.clone({
        withCredentials: true,
      });
      return next.handle(this.finalRequest);

    } else if (request.url.includes(environment.proxy.root)) {
      const token = sessionStorage.getItem('TokenProxy');

      this.headers = {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        'X-ProductCode': 'anonymous',
        Accept: '*/*',
      };

      this.finalRequest = request.clone({
        withCredentials: true,
        setHeaders: this.headers,
      });
      return next.handle(this.finalRequest);

    } else if (!request.url.includes(environment.proxy.root) || !request.url.includes(environment.proxy.login)) {
      const account = this.msalAccountService.getAccountInfo();

      if (!!!account) return next.handle(request);

      return this.authService
        .acquireTokenSilent({ scopes: ['user.read'], account: account })
        .pipe(
          switchMap((authenticationResult) => {
            const token = authenticationResult.idToken;
            this.sessionStorageService.set('Token', token);

            this.headers = {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
              'X-ProductCode': 'espdvsalesapp',
              'Ocp-Apim-Subscription-Key': environment.ApimSubscriptionKey,
              'Access-Control-Allow-Methods': '*',
              'Access-Control-Allow-Headers': '*',
              Accept: '*',
            };
            this.finalRequest = request.clone({ setHeaders: this.headers });
            return next.handle(this.finalRequest);
          })
        );
    }
  }
}
